import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';

const SupportTicket = () => {
  const [supports, setSupports] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const rowsPerPage = 10;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          setError('No authentication token found');
          setLoading(false);
          return;
        }

        const response = await axios.get(
          'https://api.safree.org/api-v2022/superAdmin/auth/v1/allSupports',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setSupports(response.data.data);
        } else {
          setError('Failed to fetch support tickets');
        }
      } catch (err) {
        console.error('Error fetching support tickets:', err);
        setError('An error occurred while fetching support tickets: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const totalPages = Math.ceil(supports.length / rowsPerPage);
  const currentRows = supports.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-12">
          <p className="sub-heading">Support Ticket</p>
        </div>
      </div>

      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Title</th>
              <th>Description</th>
              <th>Created</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {supports.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', fontSize: '42px', color: '#f54138', fontWeight: 700 }}>No Data Found</td>
              </tr>
            ) : (
              currentRows.map((ticket, index) => (
                <tr key={ticket._id}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{ticket.userName}</td>
                  <td>{ticket.email}</td>
                  <td>{ticket.title}</td>
                  <td>{ticket.description}</td>
                  <td>{new Date(ticket.created).toLocaleString()}</td>
                  <td>{ticket.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="pagination-container">
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            &laquo; Prev
          </button>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupportTicket;
